import { FormControl, FormGroup } from '@/shared/ui/Form'

/**
 * Campos de apresentação em contexto de networking.
 *
 * Todos com rótulo visível persistente e placeholder com exemplo real — o
 * `ACCESSIBILITY.md` do projeto é explícito: placeholder nunca é o único rótulo,
 * porque desaparece quando o usuário começa a digitar.
 *
 * Texto livre, então `FormControl` é o componente correto; nenhum é campo
 * especializado.
 */
export const NetworkingFields = () => (
  <div className="flex flex-col gap-4">
    <FormGroup
      name="headline"
      label="Sua apresentação em uma linha"
      placeholder="Ex.: Product manager focada em educação"
      control={FormControl}
      vertical
      margin={0}
    />
    <FormGroup
      name="company"
      label="Empresa ou organização"
      placeholder="Ex.: Tootz Soluções"
      control={FormControl}
      vertical
      margin={0}
    />
    <FormGroup
      name="job_title"
      label="Cargo"
      placeholder="Ex.: Analista de inovação"
      control={FormControl}
      vertical
      margin={0}
    />
  </div>
)
